<template>
    <div class="block my-3 -mx-3 border-b border-gray-300"></div>
</template>

<script>
export default {
    //
}
</script>
